export let calendarMonth_October = "r7eYl";
export default {calendarMonth_October};